import React from "react";
import { useTranslation } from "react-i18next";
import { InvoiceDisplayStatus } from "../../../utils/invoice.utils";

const STATUS_COLORS: Record<InvoiceDisplayStatus, string> = {
  paid: "bg-success-100 text-success-700",
  pending: "bg-warning-100 text-warning-700",
  overdue: "bg-danger-100 text-danger-700",
  cancelled: "bg-neutral-200 text-neutral-700",
  other: "bg-neutral-100 text-neutral-600",
};

interface InvoiceStatusBadgeProps {
  status: InvoiceDisplayStatus;
  /** The API's status, shown as-is when the page does not know it. */
  rawStatus?: string | null;
}

export const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status, rawStatus }) => {
  const { t } = useTranslation();
  return (
    <span
      data-testid="invoice-status"
      data-status={status}
      className={`inline-block text-xs font-semibold px-2.5 py-1 rounded-full ${STATUS_COLORS[status]}`}
    >
      {status === "other" ? rawStatus || "—" : t(`licence.invoices.status.${status}`)}
    </span>
  );
};
